var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.3627V28.8627M17.5 11.3627C17.5 10.0366 16.9732 8.76482 16.0355 7.82714C15.0979 6.88945 13.8261 6.36267 12.5 6.36267H6.25C5.91848 6.36267 5.60054 6.49437 5.36612 6.72879C5.1317 6.96321 5 7.28115 5 7.61267V23.8627C5 24.1942 5.1317 24.5121 5.36612 24.7466C5.60054 24.981 5.91848 25.1127 6.25 25.1127H13.75C14.7446 25.1127 15.6984 25.5078 16.4017 26.211C17.1049 26.9143 17.5 27.8681 17.5 28.8627M17.5 11.3627C17.5 10.0366 18.0268 8.76482 18.9645 7.82714C19.9021 6.88945 21.1739 6.36267 22.5 6.36267H28.75C29.0815 6.36267 29.3995 6.49437 29.6339 6.72879C29.8683 6.96321 30 7.28115 30 7.61267V23.8627C30 24.1942 29.8683 24.5121 29.6339 24.7466C29.3995 24.981 29.0815 25.1127 28.75 25.1127H21.25C20.2554 25.1127 19.3016 25.5078 18.5983 26.211C17.8951 26.9143 17.5 27.8681 17.5 28.8627",
    stroke: "#147B58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramsIcon);
export default __webpack_public_path__ + "static/media/ProgramsIcon.cd6fb92ea91d0e27fcd212a4e8d15cbc.svg";
export { ForwardRef as ReactComponent };